import {
    Component,
    OnInit,
    OnDestroy,
    HostBinding,
    AfterViewInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as LinkFileListActions from '../../actions/link-file-list.actions';
import { BehaviorSubject, Subject, Subscription, debounceTime, takeUntil } from 'rxjs';
import { ThumbnailsService } from '../../file-list/services/thumbnails.service';
import { BrowserSupportService } from '../../core/browser-support.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { LoggerService } from '../../core/logger.service';
import { BuildTransferItemService } from '../../transfer/services/build-transfer-item.service';
import { FileItemService } from '../../file/file-item.service';
import { canBrowserOpen, getFileExt } from '../../shared/func';
import { ActivatedRoute, Router } from '@angular/router';
import { RunUploadFolderService } from 'src/app/transfer/services/run-upload-folder.service';
import { BlendEvent, FileItem } from '../../shared/models';
import { BlendService } from '../../shared/services/blend.service';
import { IFile, IPaginate, IUploadFolderView } from 'src/sync';
import { Entry } from 'src/app/filewriter';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { UploadFolderService } from 'src/app/transfer/services/upload-folder.service';
import { CellTypes, Column, Breadcrumb, LazyLoadingPagination, Pagination } from '@material-library';
import { LinkFileListService } from '../services/link-file-list.service';
import { AppBarActionsService } from 'src/app/shared/layout/root-layout/app-bar-actions.service';
import { RootLayoutConfigService } from 'src/app/shared/layout/root-layout/root-layout-config.service';
import { FileViewService } from 'src/app/file/file-view.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { DownloadZipService } from 'src/app/transfer/services/download-zip.service';
import { environment } from '../../../environments/environment';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-link-file-list',
    templateUrl: './link-file-list.component.html',
    styleUrls: ['./link-file-list.component.scss', '../../file-list/file-list/file-list.component.scss']

})
export class LinkFileListComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('cellTemplate') cellTemplateRef: TemplateRef<any>;
    @ViewChild('iconTemplate') iconTemplateRef: TemplateRef<any>;

    public cwd: IFile;
    public list: IFile[] = [];
    public dataSource: IFile[] = [];

    public upload: number;
    public canSave: boolean;
    public previewonly: 0 | 1;
    public compat = 0;
    public initialized: boolean;
    public isRoot: boolean;

    //white label attributes
    public isWhiteLabel: boolean;
    public linkTextColor: String;

    public allowComment: 0 | 1 | 2;

    private isBusiness: 0 | 1;

    public UPLOAD_NON_VISIBLE = 2;
    public UPLOAD_VISIBLE = 1;
    public UPLOAD_DISABLED = 0;
    public isTransfering: boolean;

    public paginate: IPaginate = {
        total: 0,
        currentPage: 1,
        itemsPerPage: 50,
        numPages: 0,
        viewOffset: 0,
        viewEnd: 0,
    };
    private sub: Subscription;
    private breakpointSub: Subscription;
    private key: string;
    private passlock: string;
    public folderTransferView: IUploadFolderView;
    public fileListColumns: Column[] = [];
    public isLoading = false;
    dropFolder?: FileItem;
    public breadcrumbItems: Array<Breadcrumb> = [];
    public openUploadDialog: boolean = false;
    private isSmScreen: boolean = false;
    private PAGE_TITLE = 'Sync.com';
    public itemPerPage = 100;
    public currentIndex = 0;
    public totalItems = 0
    public loadMore = true;
    paginationConfig: any;
    public lazyLoadingPaginationConfig: LazyLoadingPagination = null;
    paginationConfig$ = new BehaviorSubject<any>(null);
    public fileListPaginationConfig: Pagination;
    private destroySubscriptions$ = new Subject<void>();
    public showImageKey: string = 'thumbsrc';

    constructor(
        private browserSupport: BrowserSupportService,
        private store: Store<fromRoot.State>,
        private thumbs: ThumbnailsService,
        private sanitizer: DomSanitizer,
        private log: LoggerService,
        public transferService: TransferService,
        private uploadFolderService: UploadFolderService,
        private buildTransferItemService: BuildTransferItemService,
        private fileItemService: FileItemService,
        private route: ActivatedRoute,
        private router: Router,
        private runUploadFolderService: RunUploadFolderService,
        private blendService: BlendService,
        private linkFileListService: LinkFileListService,
        private appBarActionsService: AppBarActionsService,
        private rootLayoutConfigService: RootLayoutConfigService,
        private fileViewService: FileViewService,
        public breakpointObserver: BreakpointObserver,
        private pageTitleService: Title,
        private downloadZipService: DownloadZipService
    ) {
        this.isLoading = true;
    }

    ngOnInit() {
        this.folderTransferView = this.runUploadFolderService.view;
        this.breakpointObserver
            .observe([`(max-width: 599px)`])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    // Condition for sm/xs screens
                    this.isSmScreen = true
                } else {
                    this.isSmScreen = false
                }
            });
        this.initStaticData();
        this.paginationConfig$
            .pipe(
                debounceTime(200),
                takeUntil(this.destroySubscriptions$)
            )
            .subscribe((paginationConfig) => {
                if (paginationConfig) {
                    this.updateThumbnails(paginationConfig);
                }
            });
    }

    ngAfterContentInit(): void {
        this.sub = this.store
            .select(fromRoot.getLinkFileListState)
            .subscribe((data) => {
                this.previewonly = data.previewonly;
                this.upload = data.upload;
                this.key = data.linkkey;
                this.compat = data.compat;
                this.isRoot = data.is_root;
                this.isBusiness = data.is_business;

                if (data.cwd) {
                    this.cwd = data.cwd;
                    this.pageTitleService.setTitle(
                        `${this.cwd.name} | ${this.PAGE_TITLE}`
                    );
                    this.breadcrumbItems = [{
                        label: this.cwd.name,
                        url: false
                    }];
                    if (data.cwd && data.is_root) {
                        let title = '';
                        if (data.cwd.type === 'file') {
                          title = data.cwd.name;
                        } else {
                          title = `Link for ${data.cwd.name}`;
                        }
                        this.rootLayoutConfigService.updateConfig({linkTitle: title});
                      }
                }
                if (data.error) {
                    if (data.error.code == 8018) {
                        // this.openState = 2; // this is a user requiring password lock
                    }
                    this.log.error(`Link file list received Error: ${data.error.code}: ${data.error.msg}`);
                }
                this.passlock = data.passwordlock;
                if (data.loaded && data.sorted) {
                    if (
                        data.pathlist.length == 1 &&
                        data.pathlist[0].sync_id == data.cwd.sync_id
                    ) {
                        this.onRowDoubleClick(data.pathlist[0]);
                    } else if (data.upload != this.UPLOAD_NON_VISIBLE) {
                        this.list = data.pathlist;
                        this.currentIndex = 0;
                        this.totalItems = this.list?.length ?? 0;
                        this.loadMore = true;
                        this.updateLazyLoadingData();
                        this.isLoading = false;
                        this.initializePagination();
                        this.fileListPaginationConfig.length = this.list.length;
                        this.paginationConfig$.next(this.paginationConfig);
                    }
                    //white label attributes
                    if (data.image_cachekey) {
                        this.isWhiteLabel = true;
                        this.linkTextColor = data.link_text_color;
                    } else {
                        this.isWhiteLabel = false;
                        this.linkTextColor = '#00adef';
                    }
                    //comment feature
                    this.allowComment = data.allow_comment;
                    this.initialized = true;
                    this.isLoading = false;
                    this.initActions();
                }
            });
    }

    ngAfterViewInit() {
        //assigning templateRef to name column as templateref only gets value in ngAfterViewInit
        this.fileListColumns = this.fileListColumns.map(column => {
            if (column.key === 'name') {
                return { ...column, templateRef: this.cellTemplateRef };
            }
            if (column.key === 'head') {
                return { ...column, templateRef: this.iconTemplateRef };
            }
            return column;
        });
    }

    public ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    updateThumbnails(paginationConfig: any) {
        this.thumbs.getThumbs(this.list, paginationConfig, true);
    }

    openUploadFolderModal() {
        this.uploadFolderService.showFolderUpload();
    }

    public changeDir = (id: number) => {
        this.isLoading = true;
        this.store.dispatch(new LinkFileListActions.ChangeDirAction(id));
        this.router.navigate([], {
            relativeTo: this.route,
            ...this.decorateFragment(),
            queryParams: { sync_id: id }
        });
    }

    public onDragEnd(event) {
        event.preventDefault();
        event.dataTransfer.effectAllowed = 'none';
        event.dataTransfer.dropEffect = 'none';
        return false;
    }
    public onDragOver(event) {
        event.preventDefault();
        return false;
    }
    public onDrop(event) {
        event.preventDefault();
        const list = event.dataTransfer.items;

        if (list && list.length > 0) {
            if (this.browserSupport.testDirUpload()) {
                let hasDirs = false;
                let items: Entry[] = [];
                for (let i = 0, len = list.length; i < len; i++) {
                    const item: Entry = list[i].webkitGetAsEntry();
                    if (item) {
                        items.push(item);
                        if (!hasDirs && item.isDirectory) {
                            hasDirs = true;
                        }
                    }
                }
                if (hasDirs) {
                    this.uploadFolderService.run(this.cwd, items, this.cwd.linkID);
                } else {
                    items = [];
                    this.transferService.queuePublicUpload(event.dataTransfer.files);
                }
            } else {
                // browser does not support dir upload
                this.transferService.queuePublicUpload(event.dataTransfer.files);
            }
        } else if (event.dataTransfer.files.length) {
            this.transferService.queuePublicUpload(event.dataTransfer.files);
        } else {
            this.log.info('No files were dropped for upload');
        }
        return false;
    }

    public showDownloadAll = () => {
        return (
            this.initialized &&
            !this.previewonly &&
            this.compat == 1 &&
            this.upload != this.UPLOAD_NON_VISIBLE &&
            // && !this.errcode
            this.list.length > 0
        );
    }

    public showfileTransferModal() {
        this.transferService.showTransfer();
    }

    isTransferComplete() {
        if (this.buildTransferItemService.view.isUpload) {
            this.isTransfering = true;
        } else if (!this.buildTransferItemService.view.isUpload && this.isTransfering && this.upload == 2) {
            this.isTransfering = true;
            return true;
        }
        return false;
    }

    public downloadZipFile = () => {
        this.downloadZipService.createZip(
            this.route.snapshot.params['cachekey'],
            this.passlock,
            this.cwd.name
        )
        this.blendService.track(BlendEvent.DOWNLOAD_AS_ZIP, {});
    }

    private getItemType(item) {
        if (this.fileItemService.isImage(item)) { return 'image'; }
        if (this.fileItemService.isText(item)) { return 'text'; }
        if (this.fileItemService.isAudio(item)) { return 'audio'; }
        if (this.fileItemService.isVideo(item)) { return 'video'; }

        if (!this.compat) { return 'default'; }

        if (this.fileItemService.isPDF(item)) {
            if (item.size > this.fileItemService.MAX_PREVIEW_SIZE_PDF && item.previewonly && !this.isBusiness) {
                return 'pdf';
            } else if (item.size <= this.fileItemService.MAX_PREVIEW_SIZE_PDF || this.isBusiness) {
                return 'doc';
            }
        } else if (this.isBusiness && this.fileItemService.isDocument(item)) {
            return 'doc';
        }

        return 'default';
    }

    /**
     * Downloads a specific file
     * @param  {Object} item The pathitem object
     * @return {Promise}
     */
    public downloadFile = async (item: IFile) => {
        if (this.compat) {
            if (item.context == 'applink') {
                const url = item.compaturl;
                window.location.href = url;
            } else {
                const url = await this.buildTransferItemService.getCompatUrl(
                    item,
                    this.buildTransferItemService.ACT_DOWNLOAD
                );
                window.location.href = url;
            }
        } else {
            await this.transferService.queuePublicDownload([item]);
            this.transferService.showTransfer();
        }
    }

    public openFile = async (item: IFile) => {
        if (item.context == 'applink') {
            const url = item.compaturl;
            window.open(url, 'blank');
        } else {
            const url = await this.buildTransferItemService.getCompatUrl(
                item,
                this.buildTransferItemService.ACT_PREVIEW
            );
            window.open(url, 'blank');
        }
    }

    public isOpenable(item: IFile) {
        if (item.context == 'link' && (item.previewonly == 8 || !this.compat)) {
            return false;
        }
        if (
            item.context == 'link' &&
            getFileExt(item.name) == 'pdf' &&
            !item.link_is_business
        ) {
            return false;
        }
        if (this.isMSOffice(item)) {
            return false;
        }

        if (!canBrowserOpen(item.name)) {
            return false;
        }
        if (item.context == 'link' && this.fileItemService.isStreamable(item.kind)) {
            return false;
        }
        return true;
    }

    public isPreviewable(item: IFile) {
        if (!this.compat && (this.fileItemService.isImage(item) || this.fileItemService.isText(item))) {
            return true;
        }
        if (this.compat &&
            (!item.transferitem &&
                item?.filetype?.viewable ||
                this.fileItemService.isStreamable(item.kind)
            )
        ) {
            return true;
        }
        return false;
    }

    public isMSOffice(item: IFile) {
        const app = this.fileItemService.getMSOfficeApp(item);
        if (app === 'None') {
            return false;
        }
        return true;
    }


    public onUpload = (files) => {
        this.transferService.queuePublicUpload(files);
    }

    private decorateQueryParams() {
        if (this.route.snapshot.queryParams['sync_id']) {
            return { queryParams: { sync_id: this.route.snapshot.queryParams['sync_id'] } };
        }
    }
    private decorateFragment() {
        if (!this.compat || this.route.snapshot.fragment) {
            return { fragment : this.route.snapshot.fragment };
        }
    }

    protected get countText() {
        if (this.isLoading) {
            return ' ';
        }
        else {
            return `${this.totalItems} ${this.totalItems === 1 ? 'item' : 'items'}`;
        }
    }

    fileIcon(item: FileItem) {
        return this.fileItemService.getFileTypeIcon(item);
    }

    private initStaticData() {
        this.lazyLoadingPaginationConfig = {
            onScrolled: this.handleScroll,
            scrollThrottleTime: 10,
            scrollOffsetPercent: 6
        };
        this.fileListColumns = [
            {
                key: 'head',
                header: '',
                isHead: true,
                type: CellTypes.templateRef,
                width: '48px',
                cell: (element: Record<string, any>) => {
                    return this.fileItemService.getFileTypeIcon(element)
                },
            },
            {
                key: 'name',
                header: 'Name',
                type: CellTypes.templateRef,
                isSortable: true,
                isPrimary: true,
                cell: (element: Record<string, any>) => {
                    return {
                        value: `${element['name'] || '-'}`
                    };
                },
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('name', isSortAsc);
                }
            },
            {
                key: 'modified',
                header: 'Modified',
                type: CellTypes.text,
                width: '190px',
                visibleMaxWidth: 725,
                cell: (element: Record<string, any>) => `${element.is_dir ? '-' : element['date_medium']}`,
                isSortable: true,
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('usertime', isSortAsc);
                }
            },
            {
                key: 'size',
                header: 'Size',
                type: CellTypes.text,
                width: '90px',
                visibleMaxWidth: 815,
                isAlignRight: true,
                cell: (element: Record<string, any>) => `${element.is_dir ? '-' : element['filesize']}`,
                isSortable: true,
                sort: (isSortAsc: boolean) => {
                    this.linkFileListService.sortList('size', isSortAsc);
                }
            },
            {
                key: 'action',
                header: 'Actions',
                type: CellTypes.action,
                width: '152px',
                isAlignRight: true,
                actionLimit: 0,
                actions: [
                    {
                        name: 'Encrypted file. No actions available.',
                        onClick: () => { },
                        shouldShow: (item: FileItem) => item.type == 'file' && !this.compat && this.previewonly &&
                            !(this.fileItemService.isImage(item) || this.fileItemService.isText(item)),
                    },
                    {
                        name: 'No actions available.',
                        onClick: () => { },
                        shouldShow: (item: FileItem) => item.type == 'file' && (!item?.filetype?.viewable &&
                            this.previewonly &&
                            !this.fileItemService.isStreamable(item.kind)) &&
                            this.compat,
                    },
                    {
                        name: 'Preview',
                        icon: 'preview',
                        onClick: this.onRowDoubleClick,
                        shouldShow: (item: FileItem) => item.type == 'file' && this.isPreviewable(item)
                    },
                    {
                        name: 'Open in browser',
                        icon: 'open-in-new',
                        onClick: this.openFile,
                        shouldShow: (item: FileItem) => item.type == 'file' && this.isOpenable(item)
                    },
                    {
                        name: 'Download',
                        icon: 'download',
                        onClick: this.downloadFile,
                        shouldShow: (item: FileItem) => item.type == 'file' && !this.previewonly,
                    },
                    {
                        name: 'Edit in Office',
                        icon: 'edit',
                        onClick: (item: FileItem) => {
                            this.fileViewService.openOfficeEdit(item, this.route);
                        },
                        shouldShow: (item: FileItem) => item.type == 'file' && this.fileViewService.showOfficeEdit(item) && !this.isSmScreen
                    },
                    {
                        name: 'View in Offce',
                        icon: 'preview',
                        onClick: (item: FileItem) => {
                            this.fileViewService.openOfficeView(item);
                        },
                        shouldShow: (item: FileItem) => item.type == 'file' && this.fileViewService.showOfficeEdit(item) && this.isSmScreen
                    }
                ]
            }
        ].filter(Boolean);

        this.fileListPaginationConfig = {
            length: this.list.length,
            pageSize: 100,
            pageSizeOptions: [10, 20, 30, 40, 50, 100],
            alignment: 'right',
            onPageChange: (event: PageEvent) => this.handlePageChange(event),
        };

        this.initializePagination();
    }


    handleScroll = async (): Promise<void> => {
        if (this.loadMore) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.updateLazyLoadingData();
                    resolve()
                }, 500);
            })
        }
    }


    updateLazyLoadingData = () => {
        let lastIndex = this.currentIndex + this.itemPerPage;

        if (lastIndex >= this.totalItems) {
            lastIndex = this.totalItems;
            this.loadMore = false;
        }
        this.dataSource = this.list.slice(0, lastIndex);
        this.currentIndex = lastIndex;

        this.handlePageChange({
            pageIndex: Math.ceil((this.currentIndex / this.itemPerPage) - 1),
            pageSize: this.paginationConfig.itemsPerPage
        })
    }

    initializePagination() {
        const total = this.list.length;
        const itemsPerPage = this.fileListPaginationConfig.pageSize;
        const currentPage = 1;

        this.paginationConfig = {
            total: total,
            currentPage: currentPage,
            itemsPerPage: itemsPerPage,
            numPages: Math.ceil(total / itemsPerPage),
            viewOffset: (currentPage - 1) * itemsPerPage,
            viewEnd: Math.min((currentPage - 1) * itemsPerPage + itemsPerPage, total)
        };
    }

    handlePageChange(event: any) {
        const { pageIndex, pageSize } = event;
        const total = this.list.length;
        const currentPage = pageIndex + 1;

        this.paginationConfig = {
            total: total,
            currentPage: currentPage,
            itemsPerPage: pageSize,
            numPages: Math.ceil(total / pageSize),
            viewOffset: (currentPage - 1) * pageSize,
            viewEnd: Math.min((currentPage - 1) * pageSize + pageSize, total)
        };

        this.paginationConfig$.next(this.paginationConfig);
    }

    onRowDoubleClick = (item: FileItem) => {
        if (item.type === 'dir') {
            this.changeDir(item.sync_id);
        } else {
            this.previewItem(item);
        }
    }

    previewItem = (item: FileItem) => {
        const link = this.getItemLink(item).replace(/^\/4\.0\//, '/'); // remove /4.0/ from the beggining of the link
        const linkhost = environment.linkhost.replace(/\/+$/, ''); //strip trailing slashes
        window.location.href = linkhost + link;
    }

    getItemLink = (item: FileItem) => {
        const type = this.getItemType(item);

        // don't overwrite sync_id as it needs to be passed in
        // so that <sync-header-previews> can have a proper back
        // button.
        if (this.router.url.includes('/dl')) {
            const navigationParams = ['/dl', this.route.snapshot.params['cachekey'], 'view', type, item.sync_id];
            // add key in navigation params array if it exists in router params, otherwise key after # in fragment will be used
            if (this.route.snapshot.params['key']) { navigationParams.splice(2, 0, this.route.snapshot.params['key']); }
            const extras = {
                ...this.decorateQueryParams(),
                ...this.decorateFragment()
            }
            let url = this.router.createUrlTree(navigationParams,extras).toString();
            if (!url.startsWith('/4.0/')) {
                url = '/4.0' + url; // Add /4.0/ at the beginning
            }
            return url;
        } else if (this.router.url.includes('/al')) {
            const extras = {
                ...this.decorateFragment()
            }
            let url = this.router.createUrlTree(['al', this.route.snapshot.params['cachekey']],extras).toString();
            if (!url.startsWith('/4.0/')) {
                url = '/4.0' + url; // Add /4.0/ at the beginning
            }
            return url;
        }
    }

    onUploadAction = () => {
        this.openUploadDialog = true;
    }

    initActions() {
        this.appBarActionsService.updateActions({
            limit: 5,
            actions: [{
                name: 'Upload',
                onClick: this.onUploadAction,
                icon: 'upload',
                shouldShow: () => this.upload,
                type: 'primary'
            }, {
                name: 'Download all',
                onClick: this.downloadZipFile,
                icon: 'download',
                shouldShow: this.showDownloadAll,
                type: 'primary'
            }],
            rowData: this.list
        })
    }
}
